export default __webpack_public_path__ + "static/media/banner-desktop-trabalhe-conosco-v1.6d4ced32.png";